import { useUserStore } from '@/store/user'
import { contractAddress, contractABI } from './config'
import TronWeb from 'tronweb'
import { TronLinkAdapter, TokenPocketAdapter, ImTokenAdapter } from '@tronweb3/tronwallet-adapters'
import {useMainStore} from "@/store/index.js";

export const check = async () => {
  //(typeof window !== "undefined" && (window as any).tronWeb)
  return new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && window.tronWeb) {
      resolve(true)
    } else {
      window.addEventListener(
        'tronWeb#initialized',
        function () {
          resolve(true)
        },
        {
          once: true
        }
      )
      // 等待10ms
      setTimeout(function () {
        resolve(false)
      }, 1000)
    }
  })
}

/**
 * 请求连接钱包
 */
export const connect = async () => {
  let result = { code: 200 }
  let isChecked = await check()
  if (isChecked) {
    try {
      let tronAccounts = false
      if (window?.tron?.isTokenPocket) {
        const tronlinkAdapter = new TronLinkAdapter()
        await tronlinkAdapter.connect()
        tronAccounts = []
        tronAccounts.push(tronlinkAdapter.address)
        // tronAccounts = await window.tokenpocket.tron.request({
        //   method: 'eth_requestAccounts'
        // })
      } else if (window?.tron?.isTronLink) {
        const tokenPocket = new TokenPocketAdapter()
        await tokenPocket.connect()
        tronAccounts = []
        tronAccounts.push(tokenPocket.address)
      } else if (!!window.imToken) {
        const adapter = new ImTokenAdapter()
        await adapter.connect()
        tronAccounts = []
        tronAccounts.push(adapter.address)
      } else {
        tronAccounts = await window.tronWeb.request({
          method: 'tron_requestAccounts'
        })
      }
      if (tronAccounts) {
        result.data = {
          type: 'TRON',
          address: tronAccounts[0] || window.tron.tronWeb.defaultAddress.base58
        }
      } else {
        result.code = 500
        // result.msg = tronAccounts.message || '请安装 TronLink 扩展插件并登录后继续操作。'
        result.msg =
          tronAccounts.message || 'Please install the TronLink extension and log in to continue.'
      }
    } catch (error) {
      result.code = 500
      result.msg = error.message
    }
  } else {
    result.code = 500
    // result.msg = '请安装 TronLink 扩展插件并登录后继续操作。'
    result.msg = 'Please install the TronLink extension and log in to continue.'
  }
  return result
}

/**
 * 初始化钱包切换监听
 */
export const initSwitchWalletEvent = async () => {
  let checked = await check()
  if (checked) {
    const userStore = useUserStore()
    window.addEventListener('message', async function (e) {
      //切换地址
      if (e.data.message && e.data.message.action == 'accountsChanged') {
        userStore.signOut()
        // setTimeout(() => location.reload(), 10)
      }
      //Network Change Message
      if (e.data.message && e.data.message.action == 'setNode') {
        // handler logic
      }
      //Disconnect website message
      if (e.data.message && e.data.message.action == 'disconnect') {
        // handler logic
        userStore.signOut()
      }
      //Successful connection message
      if (e.data.message && e.data.message.action == 'connect') {
        // handler logic
      }

      //即将废弃 用户拒绝连接
      if (e.data.message && e.data.message.action == 'rejectWeb') {
        // handler logic
      }
      //即将废弃 用户断开与网站的连接
      if (e.data.message && e.data.message.action == 'disconnectWeb') {
        // handler logic
      }

      //即将废弃 用户接受连接
      if (e.data.message && e.data.message.action == 'acceptWeb') {
        // handler logic
      }
      //即将废弃 用户请求连接到网站
      if (e.data.message && e.data.message.action == 'connectWeb') {
        // handler logic
      }
    })
  }
}

/**
 * 获取钱包余额
 */
export const getBalance = async () => {
  let res = { code: 200, data: { eth: 0, trx: 0, usdt: 0, usdc: 0 } }
  try {
    if (window?.tron?.isTronLink) {
      const tronWrap = new TronLinkAdapter()
    } else if (window?.tron?.isTokenPocket) {
      const tronWrap = new TokenPocketAdapter()
    } else if (!!window.imToken) {
      const tronWrap = new ImTokenAdapter()
    } else {
      const tronWrap = window.tronWeb
    }
    const trxBalance = await tronWrap.trx.getBalance(window.tronWeb.defaultAddress.base58)

    const usdtcontract = await tronWrap.contract().at(contractAddress['USDT'])
    const usdtBalance = await usdtcontract.balanceOf(window.tronWeb.defaultAddress.base58).call()

    const usdccontract = await tronWrap.contract().at(contractAddress['USDC'])
    const usdcBalance = await usdccontract.balanceOf(window.tronWeb.defaultAddress.base58).call()
  } catch (err) {
    res.code = 500
    res.msg = err
  }
  return res
}

/**
 * 授权
 * @param {string} spenderAddress - 授权地址
 * @param {string} type - 合约类型
 */
export const approve = async (spenderAddress, type = 'USDT') => {
  try {
    await connect()
    let adapter = window.tronWeb
    let tronWrap = window.tronWeb
    // const contract = await TronWeb.contract().at(contractAddress[type])

    let contract = await tronWeb.contract(contractABI, contractAddress[type])
    return await contract.approve(spenderAddress, tronWrap.toSun(100000000)).send()
    // return await contract.methods.approve(spenderAddress, TronWeb.toSun(100000000)).send()
  } catch (err) {
    return Promise.reject(err)
  }
}
export const checkAllowanceTRON = async () => {
  const useMain = useMainStore()
  const spenderAddress = useMain.platFormConfig.APPROVE_ADDRESS.TRON
  try {
    const tronWeb = window.tronWeb
    if (!tronWeb || !tronWeb.defaultAddress.base58) return '0'

    const owner = tronWeb.defaultAddress.base58

    const contract = await tronWeb.contract().at(contractAddress['USDC'])
    const allowance = await contract.allowance(owner, spenderAddress).call()
    return allowance.toString()
  } catch (e) {
    console.error('checkAllowanceTRON error:', e)
    return '0'
  }
}
